import React from "react";
import companyLogo from "../assets/images/Capa_1.png";
import { useTranslation } from "react-i18next";
import AnimatedElement from "./AnimatedElement";

const InfoBanner = () => {
  const { t } = useTranslation();

  const isMobile = window.innerWidth < 768;

  return (
    <section className="flex items-center justify-between md:px-6 py-10 pb-48 mx-auto mt-10 space-y-0 md:flex-row">
      <div className="container flex flex-col md:flex-row items-center justify-between mx-auto md:px-0">
        {/* Texto a la derecha */}
        <AnimatedElement
          fromDirection="right"
          disableAnimation={isMobile}
          className="flex flex-col items-start md:items-end space-y-3 md:order-2"
          style={{ marginTop: "71px", marginBottom: "81px" }}
        >
          <h1 className="text-4xl font-bold text-right color-orange-atm md:text-8xl">
            {t("banner.transforming")} <br />
            {t("banner.selfService")} <br />
            {t("banner.innovate")} <br />
            {t("banner.technology")}
          </h1>
        </AnimatedElement>

        {/* Logo a la izquierda */}
        <AnimatedElement
          fromDirection="left"
          className="pt-12 mt-auto md:mt-0 md:order-1 md:self-end"
        >
          <img
            src={companyLogo}
            alt="Company Logo"
            className="object-contain w-[350px] md:w-full h-auto"
          />
        </AnimatedElement>
      </div>
    </section>
  );
};

export default InfoBanner;
